import { DISHES_SORT_ORDER } from './dishesSortOrder';

const defaultState = {
  name: '',
  position: '',
  dishesSortOrder: DISHES_SORT_ORDER.NEWEST_FIRST,
  errors: {},
};

export default defaultState;
